import React from 'react';
import times from 'lodash/times';
import { Wrapper, MetricSkeleton } from './styles';
export default function FeaturedMetricsListSkeleton(_ref) {
  var count = _ref.count;
  return /*#__PURE__*/React.createElement(Wrapper, null, times(count, function (i) {
    return /*#__PURE__*/React.createElement(MetricSkeleton, {
      key: i,
      width: 90
    });
  }));
}
FeaturedMetricsListSkeleton.defaultProps = {
  count: 3
};